import { render, staticRenderFns } from "./CardEndereco.vue?vue&type=template&id=3e94a868&"
import script from "./CardEndereco.vue?vue&type=script&lang=js&"
export * from "./CardEndereco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports